import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Footer from '@/components/feature/Footer';
import ProfileHeader from './components/ProfileHeader';
import ProfileCampaigns from './components/ProfileCampaigns';
import ProfileSidebar from './components/ProfileSidebar';
import SupportModal from './components/SupportModal';
import { creatorProfiles } from '@/mocks/profiles';
import { campaigns } from '@/mocks/campaigns';

const ProfilePage = () => {
  const { username } = useParams<{ username: string }>();
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);

  const profile = creatorProfiles.find((p) => p.username === username) || creatorProfiles[0];
  const profileCampaigns = campaigns.filter((c) => profile.campaignIds.includes(c.id));

  return (
    <div className="min-h-screen bg-stone-50" dir="rtl">

      {/* Breadcrumb */}
      <div className="bg-white border-b border-stone-100 pt-20">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-3 flex items-center gap-2 text-xs text-stone-400">
          <Link to="/" className="hover:text-emerald-600 cursor-pointer">الرئيسية</Link>
          <i className="ri-arrow-left-s-line"></i>
          <Link to="/explore" className="hover:text-emerald-600 cursor-pointer">المبدعون</Link>
          <i className="ri-arrow-left-s-line"></i>
          <span className="text-stone-600">{profile.displayName}</span>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-8 py-8">
        {/* Profile Header - Full Width */}
        <ProfileHeader
          profile={profile}
          onSupportClick={() => setIsSupportModalOpen(true)}
        />

        {/* Main Content + Sidebar */}
        <div className="flex flex-col lg:flex-row gap-6">
          {/* Campaigns - Main */}
          <div className="flex-1 min-w-0">
            <ProfileCampaigns campaigns={profileCampaigns} creatorName={profile.displayName} />
          </div>

          {/* Sidebar */}
          <div className="w-full lg:w-72 shrink-0">
            <ProfileSidebar profile={profile} />
          </div>
        </div>
      </div>

      <Footer />

      {/* Support Modal */}
      <SupportModal
        profile={profile}
        isOpen={isSupportModalOpen}
        onClose={() => setIsSupportModalOpen(false)}
      />
    </div>
  );
};

export default ProfilePage;
